<style lang="scss">
.post-reply {}
</style>

<!-- eslint-disable -->
<template>
  <b-card class="post-reply">
    <section v-if="loading">
      <b-spinner variant="primary" label="Loading post"></b-spinner>
    </section>
    <section v-else>
      <section class="mb-1">
        <reply-send :post="post"></reply-send>
      </section>

      <section class="mt-3">
        <digital-reply-table :replies="replies"></digital-reply-table>
      </section>
<!--      <b-tabs content-class="mt-3">-->
<!--        <b-tab title="Table View" lazy>-->

<!--        </b-tab>-->
<!--&lt;!&ndash;        <b-tab title="Message View" lazy>&ndash;&gt;-->
<!--&lt;!&ndash;          <digital-reply-messages :replies="replies"></digital-reply-messages>&ndash;&gt;-->
<!--&lt;!&ndash;        </b-tab>&ndash;&gt;-->
<!--      </b-tabs>-->

    </section>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import DigitalRepliesService from '@/services/DigitalRepliesService';
import DigitalReplyTable from '@/views/postView/sections/postDigitalReply/DigitalReplyTable.vue';
import DigitalReplyMessages from '@/views/postView/sections/postDigitalReply/DigitalReplyMessages.vue';
import ReplySend from '@/views/postView/sections/postDigitalReply/ReplySend.vue';

export default {
  name: 'PostDigitalReply',
  components: {
    DigitalReplyTable,
    DigitalReplyMessages,
    ReplySend,
  },
  props: {
    post: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      replies: [],
      currentPage: 1,
      limit: 10,
    };
  },
  computed: {
    ...mapState({}),
  },
  mounted() {
    this.getReplies();
  },
  methods: {
    getReplies() {
      this.loading = true;
      DigitalRepliesService.getRepliesByPostId(this.post._id).then(res => {
        this.replies = res.data;
      }).catch(() => {
        this.$toast.error('Could not get replies, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      })
    },
  },
};
</script>
